"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactAutosuggest = _interopRequireDefault(require("react-autosuggest"));

require("./FieldSuggest.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class FieldSuggest extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      value: ""
    });

    _defineProperty(this, "onChange", (event, {
      newValue
    }) => {
      if (this.props.onChange) {
        this.props.onChange(newValue, event);
      }
    });

    _defineProperty(this, "onFetchRequested", ({
      value
    }) => {
      if (this.props.onSuggest) {
        this.props.onSuggest(value);
      }
    });

    _defineProperty(this, "onClearRequested", () => {
      if (this.props.onSuggest) {
        this.props.onSuggest();
      }
    });

    _defineProperty(this, "onSelect", item => {
      if (this.props.onSelect) {
        return this.props.onSelect(item);
      }

      return item;
    });

    _defineProperty(this, "renderSuggestion", item => {
      if (this.props.renderItem) {
        return this.props.renderItem(item);
      }

      return _react.default.createElement(_react.default.Fragment, null, JSON.stringify(item));
    });
  }

  render() {
    const _this$props = this.props,
          placeholder = _this$props.placeholder,
          value = _this$props.value,
          suggestions = _this$props.suggestions;
    const theme = {
      container: 'admin-field--suggest',
      containerOpen: 'admin-field--suggest--open',
      input: 'admin-field__input',
      inputOpen: 'admin-field__input--open',
      inputFocused: 'admin-field__input--focus',
      itemsContainer: 'admin-field__suggest',
      itemsContainerOpen: 'admin-field__suggest--open',
      itemsList: 'admin-field__suggest-list',
      item: 'admin-field__suggest-item',
      itemFirst: 'admin-field__suggest-item--first',
      itemHighlighted: 'admin-field__suggest-item--highlight',
      sectionContainer: 'admin-field__suggest-section',
      sectionContainerFirst: 'admin-field__suggest-section--first',
      sectionTitle: 'admin-field__suggest-section__title'
    };
    const inputProps = {
      placeholder: placeholder,
      value,
      onChange: this.onChange
    };
    return _react.default.createElement(_reactAutosuggest.default, {
      theme: theme,
      suggestions: suggestions,
      onSuggestionsFetchRequested: this.onFetchRequested,
      onSuggestionsClearRequested: this.onClearRequested,
      getSuggestionValue: this.onSelect,
      renderSuggestion: this.renderSuggestion,
      inputProps: inputProps
    });
  }

}

_defineProperty(FieldSuggest, "defaultProps", {
  suggestions: [],
  value: "",
  placeholder: ""
});

var _default = FieldSuggest;
exports.default = _default;
module.exports = exports.default;